import { render, staticRenderFns } from "./FilterOffersTrash.vue?vue&type=template&id=43f22b02&scoped=true"
import script from "./FilterOffersTrash.vue?vue&type=script&lang=js"
export * from "./FilterOffersTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f22b02",
  null
  
)

export default component.exports